import { Route } from '@gis/common';

export default Route
    .withPath("statics/:name", () => { return import('@/views/statics/Index.vue') })
    .withName('statics')
    .mapProps();